export const CheckoutFail = ({ className = '' }) => {
  return (
    <svg
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      width={20}
      height={20}
      viewBox='0 0 31 31'
      fill='none'
    >
      <g clipPath='url(#clip0_5128_12098)'>
        <path
          d='M3.34392 30.1308C2.6084 30.1736 1.88505 29.9291 1.32639 29.4488C0.224617 28.3405 0.224617 26.5505 1.32639 25.4421L25.4517 1.31671C26.5977 0.244413 28.3958 0.304022 29.4681 1.44997C30.4378 2.48624 30.4943 4.07902 29.6005 5.18136L5.33299 29.4488C4.78154 29.9221 4.0698 30.1662 3.34392 30.1308Z'
          fill='#E73F1D'
        />
        <path
          d='M27.4409 30.1308C26.6954 30.1276 25.981 29.8317 25.4517 29.3067L1.32629 5.18121C0.305547 3.98922 0.444322 2.19534 1.63631 1.17451C2.70019 0.263444 4.2692 0.263444 5.33298 1.17451L29.6004 25.2999C30.7461 26.3725 30.8053 28.1708 29.7328 29.3164C29.6901 29.362 29.646 29.4061 29.6004 29.4488C29.0062 29.9655 28.2242 30.2124 27.4409 30.1308Z'
          fill='#E73F1D'
        />
      </g>
      <defs>
        <clipPath id='clip0_5128_12098'>
          <rect
            width={30}
            height={30}
            fill='white'
            transform='translate(0.5 0.318604)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
